import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { UserService } from '../../../services/api/user.service';
import { UsersFormComponent } from "../components/users-form/users-form.component";
import { ActivatedRoute } from '@angular/router';
import { FormProfileCompanyComponent } from '../components/profile-company/profile-company-form.component';
import { TwoFactorSetupCardComponent } from '../components/two-factor-setup-card/two-factor-setup-card.component';
import { AlertNotificationService } from '../../../services/alert-notification.service';
import { User } from '../../../models/entities/users';
import { AlertInfo } from '../../../models/alert-info';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';

import { SavedDataInfo } from '../../../models/form/saved-data-info';

@Component({
  selector: 'app-users-edit-page',
  imports: [UsersFormComponent, FormProfileCompanyComponent, TwoFactorSetupCardComponent],
  templateUrl: './users-edit-page.component.html',
  styleUrl: './users-edit-page.component.scss'
})
export class UsersEditPageComponent implements OnChanges{
  userId!: number
  user?: User;

  constructor(
    private route: ActivatedRoute, 
    private userService: UserService,
  ) {
  }

  ngOnInit(): void {

    this.userId = Number(this.route.snapshot.paramMap.get('userId'));
    if(this.userId)
    {
      this.loadData(this.userId);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    {

    }
  }

  loadData(userId: any) {
    this.userService.detail(userId).subscribe((response: any) => {
      this.user = response.data?.user;
    });

  }

  onUsersFormSavedData(savedDataInfo: SavedDataInfo)
  {
    console.log('onUsersFormSavedData', savedDataInfo);
    if(savedDataInfo.success)
    {
      this.loadData(savedDataInfo.response?.data?.user?.userId);
    }
  }



}
